const state = () => ({
  isDesktop: true,
  isMobile: false
})

const mutations = {
  SET_IS_DESKTOP(state, payload) {
    state.isDesktop = payload
  },
  SET_IS_MOBILE(state, payload) {
    state.isMobile = payload
  }
}

const actions = {
  async nuxtServerInit({ commit, dispatch }, { route, isDesktop, isMobile }) {
    commit('SET_IS_DESKTOP', isDesktop)
    commit('SET_IS_MOBILE', isMobile)
    await dispatch('site/getSiteInfo')
    await dispatch('lottery/getPublicCp')
    // await dispatch('lottery/getCpsDetail')
  }
}

export { state, mutations, actions }
